var summary_height = 0;
window.summary_height = summary_height;
jQuery(document).ready(function() {
    "use strict";
    var $ = jQuery;
	var $product_info = $('.jora-wc-product-info');
	var $summary = $('.jora-wc-summary'),
		$summary_offset = $('.jora-wc-summary-offset'),
		$content = $('.jora-wcs-wrapper');

	if ($product_info.length) {

		var to_add = ($(window).height() - $content.height()) / 2 + $content.height();

		summary_height = $summary_offset.offset().top - to_add;
		window.summary_height = summary_height;

		var scrolled_height = $(window).scrollTop();
		if ( scrolled_height >= window.summary_height ) {
			$summary.removeClass('jora-wc-fixed')
		} else if (scrolled_height <= summary_height) {
			$summary.addClass('jora-wc-fixed')
		}

	}

	$(document).on('click', '.jora-wc-image-toggler', function (e){
		e.preventDefault();
		if ($(window).width() > 767) {
			var $link = $(this),
				$all_images = $('.woocommerce-product-gallery__image'),
				$wrapper = $('.woocommerce-product-gallery__wrapper'),
				s=($link.height()-window.innerHeight)/2,
				offset = $product_info.hasClass('full-size') ? $link.offset().top*0.55 : $link.offset().top*(100/55);
				// offset = $product_info.hasClass('full-size') ? $link.offset().top/(100/55) : $link.offset().top*(100/55);
			if ($product_info.hasClass('full-size')) {
				$("html, body").animate({ scrollTop: offset }, {
					duration: 500,
					complete: function (){
						move($wrapper.get(0)).scale(0.55).duration('.7s').end(function (){
						});
						$('.woocommerce-product-cont').css({'margin-bottom': '-' + $all_images.length * 40 + '%'})
						$product_info.removeClass('full-size');
					}
				});
			} else {
				$product_info.addClass('full-size');
				$('.woocommerce-product-cont').css({'margin-bottom': '0'});
				move($wrapper.get(0)).scale(1).duration('.7s').end(function (){
					$("html, body").animate({ scrollTop: offset }, 500);
					// $('.woocommerce-product-cont').css({'margin-bottom': '-' + $all_images.length * 40 + '%'})
				});
			}
		}
	})

	$(window).on('scroll', function() {
		var scrolled_height = $(window).scrollTop();
		if ( scrolled_height >= window.summary_height ) {
			$summary.removeClass('jora-wc-fixed')
		} else if (scrolled_height <= summary_height) {
			$summary.addClass('jora-wc-fixed')
		}
	});

	$(document).on('click', '.jora-wc-notice-close', function(e){
		e.preventDefault();
		$(this).closest('.jora-wc-notice-wrapper').fadeOut(500);
	})

})
jQuery(window).load(function (){
	"use strict";
    var $ = jQuery;
	var $product_info = $('.jora-wc-product-info');
	var $summary = $('.jora-wc-summary'),
		$summary_offset = $('.jora-wc-summary-offset'),
		$content = $('.jora-wcs-wrapper');

	if ($product_info.length) {

		var to_add = ($(window).height() - $content.height()) / 2 + $content.height();

		summary_height = $summary_offset.offset().top - to_add;
		window.summary_height = summary_height;

		var scrolled_height = $(window).scrollTop();
		if ( scrolled_height >= window.summary_height ) {
			$summary.removeClass('jora-wc-fixed')
		} else if (scrolled_height <= summary_height) {
			$summary.addClass('jora-wc-fixed')
		}

	}
})

jQuery(window).resize(function(){
	"use strict";
    var $ = jQuery;
	var $product_info = $('.jora-wc-product-info');
	var $summary = $('.jora-wc-summary'),
		$summary_offset = $('.jora-wc-summary-offset'),
		$content = $('.jora-wcs-wrapper');

	if ($product_info.length) {

		var to_add = ($(window).height() - $content.height()) / 2 + $content.height();

		summary_height = $summary_offset.offset().top - to_add;
		window.summary_height = summary_height;

		var scrolled_height = $(window).scrollTop();
		if ( scrolled_height >= window.summary_height ) {
			$summary.removeClass('jora-wc-fixed')
		} else if (scrolled_height <= summary_height) {
			$summary.addClass('jora-wc-fixed')
		}

	}
})
